import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, ShieldCheck, Zap, Gift } from 'lucide-react';
const bonuses = [{
  id: 1,
  title: 'Bono #1: Checklist Previa al Momento',
  desc: 'Una guía rápida para preparar cuerpo y mente antes de cualquier situación importante. Te ayuda a revisar los puntos clave para sentirte más seguro, enfocado y en control.',
  value: '$97 USD',
  image: 'https://cdn.magicpatterns.com/uploads/sNMVw791em4v8ZBVyRx3sg/bono_1.png'
}, {
  id: 2,
  title: 'Bono #2: Guía de Alimentos que Juegan a Favor',
  desc: 'Una guía simple de alimentos estratégicos que pueden apoyar energía, circulación, bienestar general y mejores hábitos diarios.',
  value: '$47 USD',
  image: 'https://cdn.magicpatterns.com/uploads/uSx3bYhbYCeuCuoaHdFhYZ/bono_2.png'
}, {
  id: 3,
  title: 'Bono #3: Script Mental de Calma y Control',
  desc: 'Un recurso psicológico para reducir presión mental, recuperar enfoque y entrar en un estado de calma antes de momentos importantes.',
  value: '$67 USD',
  image: 'https://cdn.magicpatterns.com/uploads/qst9zewEnLcYBeQjfcW1Cr/bono_3.png'
}, {
  id: 4,
  title: 'Bono #4: Tracker de Progreso y Señales de Mejora',
  desc: 'Una herramienta para medir avances, detectar señales de mejora y mantener disciplina durante el proceso de 7 días.',
  value: '$97 USD',
  image: 'https://cdn.magicpatterns.com/uploads/uq9mTugQMXaba57xBmpKsU/bono_4.png'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-slate-950 relative overflow-hidden" data-id="element-45">
      {/* Background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-blue-900/10 rounded-full blur-[120px] -z-10 pointer-events-none" data-id="element-46"></div>

      <div className="max-w-6xl mx-auto" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-48">
          <div className="inline-flex items-center justify-center p-3 bg-blue-500/10 rounded-full mb-6" data-id="element-49">
            <Gift className="w-8 h-8 text-blue-500" data-id="element-50" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-6 leading-tight" data-id="element-51">
            ADEMÁS, HOY RECIBES{' '}
            <span className="text-blue-400" data-id="element-52">4 BONOS EXCLUSIVOS</span>
          </h2>
          <p className="text-lg md:text-xl text-slate-300 max-w-3xl mx-auto leading-relaxed" data-id="element-53">
            No solo obtienes el protocolo principal. También recibirás
            herramientas prácticas para medir tu avance, preparar tu cuerpo,
            dominar tu mente y acelerar tu sensación de control.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8 mb-16" data-id="element-54">
          {bonuses.map((bonus, i) => <motion.div key={bonus.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-slate-900 border border-slate-800 rounded-3xl overflow-hidden shadow-xl flex flex-col sm:flex-row group hover:border-blue-500/30 transition-colors duration-300" data-id="element-55">
              <div className="sm:w-2/5 shrink-0 overflow-hidden relative" data-id="element-56">
                <div className="absolute inset-0 bg-blue-500/10 group-hover:bg-transparent transition-colors duration-300 z-10" data-id="element-57"></div>
                <img src={bonus.image} alt={bonus.title} loading="lazy" decoding="async" className="w-full h-full object-cover min-h-[200px] transform group-hover:scale-105 transition-transform duration-500" data-id="element-58" />
              </div>
              <div className="p-6 sm:w-3/5 flex flex-col justify-between" data-id="element-59">
                <div data-id="element-60">
                  <h3 className="text-xl font-bold text-white mb-3 leading-snug" data-id="element-61">
                    {bonus.title}
                  </h3>
                  <p className="text-slate-400 text-sm leading-relaxed mb-4" data-id="element-62">
                    {bonus.desc}
                  </p>
                </div>
                <div className="inline-flex items-center gap-2 bg-slate-950 px-4 py-2 rounded-lg border border-slate-800 self-start" data-id="element-63">
                  <Zap className="w-4 h-4 text-amber-500" data-id="element-64" />
                  <span className="text-amber-500 font-bold text-sm" data-id="element-65">
                    Valor: {bonus.value}
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="max-w-3xl mx-auto bg-slate-900 border-2 border-blue-500/50 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden shadow-[0_0_30px_rgba(37,99,235,0.15)]" data-id="element-66">
          {/* Subtle inner glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 bg-blue-500/10 blur-3xl rounded-full pointer-events-none" data-id="element-67"></div>

          <div className="relative z-10" data-id="element-68">
            <h3 className="text-2xl md:text-3xl font-bold text-white mb-4" data-id="element-69">
              Valor total del paquete:{' '}
              <span className="text-slate-400 line-through decoration-red-500/50" data-id="element-70">
                $367 USD
              </span>
            </h3>
            <p className="text-lg text-slate-300 mb-8 leading-relaxed" data-id="element-71">
              Hoy no pagas $367. Tampoco $59.99. Accedes al protocolo completo +
              los 4 bonos por solo:
            </p>

            <div className="mb-8" data-id="element-72">
              <div className="text-6xl md:text-7xl font-extrabold text-amber-500 drop-shadow-[0_0_15px_rgba(245,158,11,0.3)] mb-3" data-id="element-73">
                $14.99 <span className="text-3xl md:text-4xl" data-id="element-74">USD</span>
              </div>
              <p className="text-blue-400 font-medium" data-id="element-75">
                Pago único. Acceso inmediato. Todos los bonos incluidos.
              </p>
            </div>

            <a href="#comprar" className="inline-flex justify-center items-center gap-2 w-full sm:w-auto bg-blue-600 hover:bg-blue-500 text-white font-bold text-lg py-5 px-8 rounded-full transition-all duration-300 shadow-[0_0_25px_rgba(37,99,235,0.5)] hover:shadow-[0_0_40px_rgba(37,99,235,0.7)] hover:scale-105 active:scale-95" data-id="element-76">
              <Zap className="w-6 h-6 shrink-0" data-id="element-77" />
              DESCARGAR PROTOCOLO + BONOS AHORA
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}